var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "inline-block",
      "position": "relative"
    }
  }, [_c('i', {
    staticClass: "fa",
    class: _vm.iconName,
    style: ({
      'font-size': _vm.iconSize,
      'color': _vm.iconColor
    }),
    on: {
      "click": function($event) {
        _vm.panelShow = !_vm.panelShow
      }
    }
  }), _vm._v(" "), (_vm.panelShow) ? _c('div', {
    staticClass: "emoji-wrap",
    class: _vm.panelCalss
  }, [_c('vue-emoji', {
    on: {
      "select": _vm.emojiChoosed
    }
  })], 1) : _vm._e()])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1c69ef1e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/plugins/components/index.vue
// module id = 33e0
// module chunks = 1